document.addEventListener( 'DOMContentLoaded', function () {
	const splideNews = document.querySelector( '.splide-news-shortcode' );
	if ( splideNews ) {
		new Splide( splideNews, {
			type   : 'loop',
			perPage: 3,
			gap: '24px',
			autoHeight: true,
			breakpoints: {
				576: {
					perPage: 1
				},
				992: {
					perPage: 2
				}

			}
		} ).mount();
	}
	const splideAmbasadors = document.querySelector( '.splide-ambasadors-shortcode' );
	if ( splideAmbasadors ) {
		new Splide( splideAmbasadors, {
			type   : 'loop',
			perPage: 3,
			gap: '24px',
			autoHeight: true,
			breakpoints: {
				576: {
					perPage: 1
				},
				992: {
					perPage: 2
				}

			}
		} ).mount();
	}
});
